<template>
    <MainLayout class="pb-5">
        <Banner
            slot="center"
            :img="headerImage"
            :title="$t('tests.cute.banner.title')"
            :body="$t('tests.cute.banner.description')"
        >
        </Banner>

        <TestItem
            slot="center"
            v-for="test in tests"
            :key="test.id"
            :id="test.id"
            :title="$t(`tests.cute.tests.${test.id}.label`)"
            :measurement="$t(`tests.cute.tests.${test.id}.measurement`)"
            :task="$t(`tests.cute.tests.${test.id}.task`)"
            :testTime="test.time"
            :fullTestTime="test.fullTime"
            :open="selectedTest == test.id"
            :videoLink="test.videoLink"
            @click="toggleTestItem"
            @open-test="openTest"
        />
        <!--<CompanyCarousel slot="center" />-->

        <CuteLogo slot="right" />
        <TestShortcuts
            slot="right"
            @open-test="openTest"
            :tests="tests"
            :testsCompleted="hasCompletedTests"
        />
        <StartTestButton
            slot="right"
            @click="openTest"
            :label="hasCompletedTests ? $t('tests.cute.seeYourScore') : null"
        />
        <Videos slot="right" :items="videos" />
        <div
            slot="right"
            class="d-flex align-items-center pointer"
            @click="openSampleReport"
        >
            <BaseIcon
                name="download"
                class="mr-2"
                style="color:rgba(0,0,0,0.4)"
            />
            <p class="mb-0 caption mute" style="text-decoration:underline">
                {{ $t('tests.cute.seeSampleReport') }}
            </p>
        </div>
        <!-- <ProfileModule slot="right" /> -->
    </MainLayout>
</template>

<script>
// Project Components
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';

// Page components
import CuteLogo from './CuteLogo';
import TestShortcuts from './TestShortcuts';
import TestItem from './TestItem';
import StartTestButton from './StartTestButton';
import Videos from './Videos';
import CompanyCarousel from './Carousel.Company';

// Assets
import HeaderImage from '~/assets/img/Test.jpeg';
import CuteSvg from '~/assets/img/cut-e.svg';

// Utils
import i18n from '~/i18n';
import DialogService from '~/services/DialogService';

const NONE = -1; // NONE indicates that no test is selected

// Test statuses
const NEW = 1;
const IN_PROGRESS = 2;
const COMPLETED = 4;
const BLOCKED = 5;

export default {
    name: 'Dashboard',
    components: {
        MainLayout,
        ProfileModule,
        CuteLogo,
        TestShortcuts,
        TestItem,
        StartTestButton,
        Videos,
        CompanyCarousel,
    },
    props: {
        testData: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        headerImage: HeaderImage,
        cuteSvg: CuteSvg,
        tests: [
            {
                id: 102,
                time: '10-15',
                videoLink: 'https://youtu.be/N-cTZxwAaA4',
            },
            {
                id: 311,
                time: 12,
                fullTime: 17,
                videoLink: 'https://bcove.video/2UtCGPG',
            },
            {
                id: 312,
                time: 12,
                fullTime: 17,
                videoLink: 'https://bcove.video/2UoLQwC',
            },
            {
                id: 606,
                time: '10-15',
                /*
                videoLink:
                    'https://youtu.be/N-cTZxwAaA4',
                //This video link points to test 1, not 4
                */
            },
        ],
        videos: [
            {
                id: 1,
                title: "David Barrett's advice for graduates",
                img:
                    'https://content.gethighered.global/cute/Cute_Media_Thumbnail.jpg',
                videoLink: 'z13om7vxc6',
            },
        ],
        selectedTest: 102, // NONE indicates that no test is selected,
        consented: false, // When consenting, this bool will be set to true, so we don't have to fetch the status from the server
    }),
    computed: {
        hasConsented() {
            return Boolean(this.testData && this.testData.consented);
        },
        hasCompletedTests() {
            // Can see scores when all the tests are completed
            const statuses =
                this.testData && this.testData.statuses
                    ? this.testData.statuses
                    : [];

            const availableTest = statuses.filter(
                test => test.status !== -1 // Filters away tests with no existing status
            );
            return (
                statuses.filter(test => test.status === COMPLETED).length ===
                availableTest.length
            );
        },
    },
    methods: {
        openTest() {
            // If the user has not consented the cut-e terms yet, consent first.
            if (!this.hasConsented && !this.consented) {
                DialogService.openCuteConsentDialog(this.testData.link, {
                    consented: () => (this.consented = true),
                    close: () =>
                        this.$interfaces.dialogModal.getState().resolver.res(),
                });
                return;
            }

            window.open(this.testData.link, '_blank');
        },
        openSampleReport() {
            window.open(
                'https://content.gethighered.global/cute/Cute_Sample_Report.pdf',
                '_blank'
            );
        },
        toggleTestItem(testId) {
            this.selectedTest = this.selectedTest === testId ? NONE : testId;
        },
    },
};
</script>

<style scoped></style>
